import i18n from "../i18n";

export default {
    install(Vue) {
        Vue.prototype.$confirmLeaveDialog = async function() {
            if (window.showBeforeUnload) {
                let result = ! await this.$dialog.confirm({
                    text: i18n.t('You may have unsaved changes. Consider saving them before you leave!'),
                    title: i18n.t('Unsaved Changes'),
                    persistent: true,
                    actions: {
                        false: i18n.t('Discard Changes'),
                        true:  i18n.t('Continue Edit'),
                    },
                });
                if (result) {
                    window.showBeforeUnload = false;
                }

                return result;
            }

            return true;
        }
    }
}